/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import { useQuery } from 'react-query';
import { getFeatureAccess } from '@apis/adminReports';
import { useParams } from 'react-router-dom';
import { useCurrentCourse } from '@reducers/courses/hooks';
import { useUser } from '@reducers/user/hooks';
import {
  FEATURE_FLAG_CACHE_TIME,
  FeatureFlagAccessResponse,
  FeatureFlagConfig,
} from './types';
import { checkUserAccess } from './utils';

// --------------------------------   hooks ------------------------------------------------------------
export const useGetOrganizationData = () => {
  const courseDetail = useCurrentCourse();
  const { organization } = courseDetail;
  return {
    organizationId: organization?.id,
    districtId: organization?.district?.id,
  };
};

export const useFeatureFlagEnabled = ({
  featureName,
  suspense = false,
}: FeatureFlagConfig) => {
  const { courseId, sectionId } = useParams();
  const { organizationId, districtId } = useGetOrganizationData();
  const { id: userId } = useUser();

  const result = useQuery<boolean>(
    [
      'hasFeatureFlagAccess',
      { featureName, courseId, sectionId, organizationId, districtId, userId },
    ],
    async () => {
      const res = (await getFeatureAccess(featureName)) as unknown as {
        response: { data: FeatureFlagAccessResponse };
      };
      return checkUserAccess(res?.response?.data as FeatureFlagAccessResponse, {
        courseId,
        sectionId,
        organizationId,
        districtId,
        userId,
      });
    },
    {
      staleTime: FEATURE_FLAG_CACHE_TIME,
      suspense,
      refetchOnWindowFocus: false,
      enabled: !!featureName,
    },
  );

  return result?.data;
};
